import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router';
import { Spin } from 'antd';
import { useProject } from '../hooks';

export const ProjectRouteGuard: React.FC = () => {
  const { project, activePhase, loading, getPhaseById } = useProject();
  const navigate = useNavigate();
  const location = useLocation();
  const { phaseId } = useParams();

  useEffect(() => {
    if (loading || !activePhase || !project) return;

    const activePath = `/project/${project.id}/phase/${activePhase.id}`;
    const isProjectPath = location.pathname.startsWith('/project');

    const hasPhase = phaseId ? Boolean(getPhaseById(phaseId)) : false;
    const shouldRedirect =
      isProjectPath && (!phaseId || !hasPhase || phaseId !== activePhase.id);

    if (shouldRedirect) {
      navigate(activePath, { replace: true });
    }
  }, [activePhase, getPhaseById, loading, location.pathname, navigate, phaseId, project]);

  if (loading || !project) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
        <Spin />
      </div>
    );
  }

  return <Outlet />;
};
